<template>
  <div>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <div class="field">
            <p><router-link v-bind:to="'/clients/create'" class="button is-info">Create new application</router-link></p>
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <p>Total: <strong>{{ this.$store.state.clientsTotal | numberDisplay }}</strong> applications</p>
        </div>

        <div class="level-item">
          <div class="field has-addons">
            <div class="control">
              <input v-model="searchValue" class="input" type="text" placeholder="Find by" v-on:keyup.enter="searchClients">
            </div>
            <div class="control">
              <span class="select">
                <select v-model="searchKey">
                  <option value="name">name</option>
                  <option value="package_name">package</option>
                  <option value="platform">platform</option>
                </select>
              </span>
            </div>
            <div class="control">
              <button class="button is-primary" v-on:click="searchClients">Search</button>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <pagination
      v-bind:urlBuilder="buildPaginatorUrls"
      v-bind:currentPage="currentPage"
      v-bind:lastPage="lastPage"
      v-bind:displayPage="5"
      class="is-small" />

    <table class="table is-striped is-fullwidth">
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Package name</th>
          <th>Platform</th>
          <th>Devices</th>
          <th>Cameras</th>
          <th>Created at</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!this.$store.state.clients.length">
          <td colspan="7" class="has-text-centered has-text-grey">No clients found</td>
        </tr>
        <tr v-for="item in this.$store.state.clients">
          <td>{{ item.id }}</td>
          <td><router-link v-bind:to="`/clients/${item.id}`">{{ item.name }}</router-link></td>
          <td>{{ item.package_name }}</td>
          <td>{{ item.platform }}</td>
          <td>{{ item.devices_count }}</td>
          <td>{{ item.cameras_count }}</td>
          <td>{{ item.created_at }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import Pagination from 'vue-bulma-pagination'

  export default {
    data () {
      return {
        searchValue: this.$route.query.name ||
          this.$route.query.package_name ||
          this.$route.query.platform ||
          '',
        searchKey: this.$route.query.name ? 'name'
          : this.$route.query.package_name ? 'package_name'
          : this.$route.query.platform ? 'platform'
          : 'name',

        searchParams: {}
      }
    },

    computed: {
      currentPage () {
        return parseInt(this.$route.query.page) || 1
      },

      lastPage () {
        return Math.ceil(this.$store.state.clientsTotal / 20)
      }
    },

    methods: {
      buildPaginatorUrls (page) {
        return { query: { ...this.$route.query, page } }
      },

      searchClients () {
        this.searchParams[this.searchKey] = this.searchValue

        // Clean empty fields
        Object.keys(this.searchParams)
          .filter(key => !this.searchParams[key])
          .forEach(key => delete this.searchParams[key])

        this.$router.push({
          path: `/clients`,
          query: this.searchParams
        })
      }
    },

    created () {
      this.$store.dispatch('getClients', {
        params: {
          ...this.$route.query,
          include: 'devices_count,cameras_count,articles_count'
        }
      })
    },

    watch: {
      '$route.query' (query) {
        this.$store.dispatch('getClients', {
          params: {
            ...this.$route.query,
            include: 'devices_count,cameras_count,articles_count'
          }
        })
      },

      // Delete old search parameter
      // to prevent sending two parameters at the same time
      // because the form visually doesn't support this case
      searchKey (newSearchKey, oldSearchKey) {
        delete this.searchParams[oldSearchKey]
      }
    },

    components: {
      Pagination
    }
  }
</script>



// WEBPACK FOOTER //
// ClientList.vue?5a3d3bfe